import { render, staticRenderFns } from "./ChallengeDetails.vue?vue&type=template&id=3370d98a&scoped=true"
import script from "./ChallengeDetails.vue?vue&type=script&lang=js"
export * from "./ChallengeDetails.vue?vue&type=script&lang=js"
import style0 from "./ChallengeDetails.vue?vue&type=style&index=0&id=3370d98a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3370d98a",
  null
  
)

export default component.exports